// Seed data: configurable online forms + sample submissions.

export const seedForms = [
  {
    id: "seed-form-1",
    slug: "membership-enquiry",
    title: "Membership Enquiry",
    description:
      "Interested in becoming a member of The Bombay Catholic Sabha? Fill in this form and your nearest unit will get in touch.",
    fields: [
      { name: "full_name", label: "Full Name", type: "text", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      { name: "phone", label: "Phone / WhatsApp", type: "tel", required: true },
      { name: "parish", label: "Your Parish", type: "text", required: true },
      { name: "message", label: "Message (optional)", type: "textarea", required: false },
    ],
    is_active: true,
  },
  {
    id: "seed-form-2",
    slug: "volunteer-registration",
    title: "Volunteer Registration",
    description:
      "Volunteer for BCS drives — voter registration, environment initiatives, youth programmes and outreach.",
    fields: [
      { name: "full_name", label: "Full Name", type: "text", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      { name: "phone", label: "Phone / WhatsApp", type: "tel", required: true },
      {
        name: "interest",
        label: "Area of Interest",
        type: "select",
        required: true,
        options: [
          "Socio Civic & Political Forum",
          "Environment Forum",
          "Youth & Training Forum",
          "General Volunteering",
        ],
      },
      { name: "availability", label: "Availability", type: "text", required: false },
    ],
    is_active: true,
  },
  {
    id: "seed-form-3",
    slug: "civic-issue-report",
    title: "Report a Civic Issue",
    description:
      "Report a civic issue in your ward — the Socio Civic & Political Forum will take it up with the concerned authorities.",
    fields: [
      { name: "full_name", label: "Full Name", type: "text", required: true },
      { name: "phone", label: "Phone", type: "tel", required: true },
      { name: "ward_area", label: "Ward / Area", type: "text", required: true },
      { name: "issue", label: "Describe the issue", type: "textarea", required: true },
    ],
    is_active: true,
  },
  {
    id: "seed-form-4",
    slug: "lifetime-membership-application",
    title: "Application for Lifetime Membership to the BCS",
    description:
      "Official application for life membership. Entrance fee ₹25 and life membership fee ₹125 apply.",
    fields: [
      {
        name: "title",
        label: "Title",
        type: "select",
        required: true,
        options: ["Mr", "Mrs", "Ms", "Miss", "Dr", "Fr", "Sr", "Other"],
      },
      { name: "first_name", label: "First Name", type: "text", required: true },
      { name: "middle_name", label: "Middle Name", type: "text", required: false },
      { name: "last_name", label: "Last Name", type: "text", required: true },
      { name: "date_of_birth", label: "Date of Birth", type: "date", required: true },
      { name: "age", label: "Age", type: "text", required: true },
      { name: "residential_address", label: "Residential Address", type: "textarea", required: true },
      { name: "telephone", label: "Telephone", type: "tel", required: false },
      { name: "mobile", label: "Mobile", type: "tel", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      { name: "parish", label: "Parish", type: "text", required: true },
      { name: "parish_location", label: "Parish Location", type: "text", required: true },
      { name: "occupation_profession", label: "Occupation / Profession", type: "text", required: true },
      { name: "office_address", label: "Office Address (Optional)", type: "textarea", required: false },
      {
        name: "areas_of_interest",
        label: "Areas of Interest (select all that apply)",
        type: "checkboxes",
        required: true,
        options: [
          "Civic & Political",
          "Social Action",
          "Inter-Religious",
          "Environment Protection",
          "Youth Activities",
        ],
      },
      {
        name: "interested_in_volunteering",
        label: "Interested in volunteering?",
        type: "select",
        required: true,
        options: ["Yes", "No"],
      },
      {
        name: "declaration_age_and_aims",
        label:
          "Declaration: I confirm I am above 18 years of age and accept the Aims & Objects of the Sabha",
        type: "select",
        required: true,
        options: ["Yes, I confirm"],
      },
      {
        name: "digital_signature",
        label: "Signature / Digital consent (type your full name)",
        type: "text",
        required: true,
      },
      {
        name: "entrance_fee_acknowledgement",
        label: "Entrance Fee: ₹25",
        type: "select",
        required: true,
        options: ["I acknowledge the entrance fee of ₹25"],
      },
      {
        name: "life_membership_fee_acknowledgement",
        label: "Life Membership Fee: ₹125",
        type: "select",
        required: true,
        options: ["I acknowledge the life membership fee of ₹125"],
      },
      {
        name: "payment_method",
        label: "Payment method",
        type: "select",
        required: true,
        options: [
          "UPI / Online transfer",
          "Bank transfer (NEFT/RTGS)",
          "Cheque",
          "Cash at BCS office",
          "Other",
        ],
      },
    ],
    is_active: true,
  },
];

export const seedSubmissions = [
  {
    id: "seed-sub-1",
    form_slug: "membership-enquiry",
    data: {
      full_name: "Sample Enquiry — Melissa Pinto",
      email: "melissa@example.com",
      phone: "+91 98200 00001",
      parish: "St. Peter's Church, Bandra",
      message: "Would like to join the Bandra unit.",
    },
    status: "new",
    created_at: "2026-06-01T10:30:00Z",
  },
  {
    id: "seed-sub-2",
    form_slug: "volunteer-registration",
    data: {
      full_name: "Sample Volunteer — Trevor Lobo",
      email: "trevor@example.com",
      phone: "+91 98200 00002",
      interest: "Environment Forum",
      availability: "Weekends",
    },
    status: "reviewed",
    created_at: "2026-05-22T15:00:00Z",
  },
];
